






























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

const namespace: string = "grant";

@Component({
  components: {
    DialogComponent: () =>
      import("@/components/common/Dialog/DialogComponent.vue"),
  },
})
export default class OwnershipChange extends Vue {
  @Prop() items: any;
  @Prop() transactionId: number;
  @Prop() userId: number;
  @Prop() canView: boolean;

  dialog: boolean = false;
  dialogConfirm: boolean = false;

  public get ownerId(): number {
    return this.userId;
  }

  public set ownerId(value: number) {
    this.$emit('update:userId', value)
  }

  transferOwnership() {
    this.$emit("transferOwnership", { id: this.transactionId, userId: this.ownerId });

    this.dialogConfirm = false;
    this.dialog = false;
  }

  showConfirm() {
    this.dialogConfirm = true;
  }

  closeConfirm() {
    this.dialogConfirm = false;
  }
}
